module.exports = __webpack_public_path__ + "img/info.e3a4561a.svg";